type Props = {
  disabled?: boolean;
  onPickFile: (file: File) => void;
};

export function BoardAudioButton({ disabled, onPickFile }: Props) {
  function onChange(ev: React.ChangeEvent<HTMLInputElement>) {
    const file = ev.target.files?.[0];
    ev.target.value = "";
    if (file) onPickFile(file);
  }

  return (
    <label
      className={`wb-tool-icon-btn wb-tool-icon-btn--ghost${disabled ? " is-disabled" : ""}`}
      title="Аудио (MP3 / запись)"
      aria-label="Добавить аудио"
    >
      <input
        type="file"
        accept="audio/mpeg,audio/mp3,audio/webm,audio/ogg,audio/wav,audio/mp4,.mp3,.webm,.ogg,.wav,.m4a"
        hidden
        disabled={disabled}
        onChange={onChange}
      />
      <svg
        className="wb-tool-icon-btn__svg"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M9 18V5l12-2v13" />
        <circle cx="6" cy="18" r="3" />
        <circle cx="18" cy="16" r="3" />
      </svg>
    </label>
  );
}
